import type { ReactElement } from "react";
import { CmtsRcaContainer } from "../../core/containers/domain/rcacapaRouteContainers.js";
import type { CmtsHostRuntime } from "../../../app/appRuntime.js";

export function Component(props: { readonly runtime: CmtsHostRuntime }): ReactElement {
  return <CmtsRcaContainer runtime={props.runtime} />;
}

export default Component;
